import { postResourcesWalletAdapter } from '@api/FW/adapters/balance/postResources.adapter';
import { postVirtualWalletlBalanceAdapter } from '@api/FW/adapters/balance/postVirtualWalletlBalance.adapter';
import { getQueryParams, httpApi } from '@api/FW/http.api';
import {
	VirtualWalletlBalance,
	VirtualWalletlBalanceAdapter,
} from '@interfaces/FW/balance/balance';
import { Resources, ResourcesAdapter } from '@interfaces/FW/Resources';

export const postResources2 = (method: string, cards: string[]): Promise<Resources[]> => {
	return httpApi
		.post<ResourcesAdapter[]>(
			`Resources2/${method}/1`,
			{ CARDS: cards },
			{ params: getQueryParams() },
		)
		.then(({ data }) => {
			//console.log(data)
			return postResourcesWalletAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};

interface moveBalanceData {
	Source: string;
	Destination: string;
	Good: string;
	Count: number;
}

export const postMoveBalanceBulk = (
	sourceType: string,
	destType: string,
	data: moveBalanceData[],
) => {
	return httpApi
		.post(`MoveBalanceBulk/${sourceType}/${destType}`, data, {
			params: getQueryParams(),
		})
		.then((data) => {
			// console.log(data)
			return data;
		})
		.catch((err) => {
			throw err;
		});
};

export const postOverdraft = (walletGUID: string, value: string) => {
	return httpApi
		.post(
			`Overdraft/${walletGUID}/${value}`,
			{},
			{
				params: getQueryParams(),
			},
		)
		.then((data) => {
			// console.log(data)
			return data;
		})
		.catch((err) => {
			throw err;
		});
};

export const postVirtualWalletlBalance = (
	data: {},
	dataAction = 1,
	type = 0,
): Promise<VirtualWalletlBalance[] | undefined> => {
	return httpApi
		.post<VirtualWalletlBalanceAdapter[]>(
			`VirtualWalletlBalance/${dataAction}/${type}`,
			{ ...data },
			{ params: getQueryParams() },
		)
		.then(({ data }) => {
			return data ? postVirtualWalletlBalanceAdapter(data) : data;
		})
		.catch((err) => {
			throw err;
		});
};
